














































































































































































import dayjs from "dayjs";
import GlobalMixin from "@/shared/mixins/globalMixin";
import { Component, Mixins } from "vue-property-decorator";
import AdicionarLead from "./modals/AdicionarLead.vue";
import ImportarExcel from "./modals/ImportarExcel.vue";
import RetornoOctadesk from "./modals/RetornoOctadesk.vue";
import ExportarOctadesk from "./modals/ExportarOctadesk.vue";
import { LeadService, Lead } from "@/services/lead.service";
import LeadCard from "./components/LeadCard.vue";

@Component({
  components: {
    AdicionarLead,
    ImportarExcel,
    RetornoOctadesk,
    ExportarOctadesk,
    LeadCard,
  },
})
export default class Leads extends Mixins(GlobalMixin) {
  leadsOportunidades: Lead[] | null = null;
  leadsPrimeiroContato: Lead[] | null = null;
  leadsSegundoContato: Lead[] | null = null;
  leadsAtendimento: Lead[] | null = null;

  items = [
    { title: "Importar Via Excel" },
    { title: "Retorno de Leads do Octadesk" },
  ];

  async importarExcel() {
    const modal = this.$refs.importarExcel as ImportarExcel;
    await modal.importarExcel();
    this.fetchLeads();
  }

  async retornoOctadesk() {
    const modal = this.$refs.retornoOctadesk as RetornoOctadesk;
    await modal.retornoOctadesk();
    this.fetchLeads();
  }

  async adicionarLead() {
    const modal = this.$refs.adicionarLead as AdicionarLead;
    await modal.adicionarLead();
    this.fetchLeads();
  }

  async exportarOctadesk() {
    const modal = this.$refs.exportarOctadesk as ExportarOctadesk;
    await modal.exportarOctadesk();
  }

  mounted() {
    this.fetchLeads();
  }

  async fetchLeads() {
    this.startLoader();
    try {
      this.leadsOportunidades = await LeadService.listarLeads(0);
      this.leadsPrimeiroContato = await LeadService.listarLeads(1);
      this.leadsSegundoContato = await LeadService.listarLeads(2);
      this.leadsAtendimento = await LeadService.listarQualificados();
    } finally {
      this.stopLoader();
    }
  }

  formatMes(data: string) {
    return dayjs(data).locale("pt-br").format("MMM").toUpperCase();
  }

  formatDia(data: string) {
    return dayjs(data).format("DD");
  }

  descricaoTipoLead(tipoLead: number) {
    switch (tipoLead) {
      case 1:
        return "Indicação";
      case 2:
        return "Campanha";
      case 3:
        return "Prospecção";
      default:
        return "";
    }
  }

  groupBy(arr: any[], property: string | number) {
    return arr.reduce(function (memo, x) {
      if (!memo[x[property]]) {
        memo[x[property]] = [];
      }
      memo[x[property]].push(x);
      return memo;
    }, {});
  }
}
